import React, { Component } from 'react';
import NavButton from '../component/NavButton.js';

export default class LovUserNav extends Component{
	constructor(props){
		super(props);
		this.handleThankHover = this.handleThankHover.bind(this);
		this.handlePrizeHover = this.handlePrizeHover.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.state = {thankhover:false,prizehover:false,current:'Home'};
	}
	
	handleThankHover(){ //handles mouse hover over "Thankyous" button, display dropdown buttons
		this.setState({thankhover:!this.state.thankhover});
	}

	handlePrizeHover(){ //handles mouse hover over "Prizes" button, display dropdown buttons
		this.setState({prizehover:!this.state.prizehover});
	}

	handleClick(navTo){  //method that handles user click on a nav button,passes info up to main in order to handle navigation
		this.props.navClick(this.state.current,navTo);
		this.setState({current:navTo});
	}

	render(){
		let manager;
		const divStyle = "fl w-25 ma0 bl pl1 pr1 white h-100 userNavDiv";
		const buttonstyle = "dim b w-100 pt2 pb2 bn white bg-navy ml1 mr1 pointer";
		const disbuttonstyle = "b w-100 pt2 pb2 bn white bg-navy ml1 mr1";
		const dropstyle = "b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib";
		const dropend = "b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib br--bottom br3";
		let endstyle = dropend;
		if (this.props.user === "manager" || this.props.user === "asm_regional"){
			 manager = <NavButton name="Pending" onClick={this.handleClick} styles={dropend}/>;
			 endstyle = dropstyle;
		}
		const options = <div className="z-1 absolute shadow-3 br--bottom br3 userDropDiv"><NavButton name="Shop" onClick={this.handleClick} styles={dropstyle}/>
						<NavButton name="Orders" onClick={this.handleClick} styles={dropend}/></div>;
		const thankyous = <div className="z-1 absolute shadow-3 br--bottom br3 userDropDiv"><div><NavButton name="Create" onClick={this.handleClick} styles={dropstyle}/></div>
						  <NavButton name="Sent" onClick={this.handleClick} styles={dropstyle}/>
						  <NavButton name="Received" onClick={this.handleClick} styles={endstyle}/>{manager}</div>;
		return(
			<div className="fl w-100">
				<div className="fl w-25 ma0">
					<NavButton name="Home" onClick={this.handleClick} styles={buttonstyle}/>
				</div>
				<div className={divStyle}>
					<div onMouseEnter={this.handleThankHover} onMouseLeave={this.handleThankHover}>
						<NavButton name="Thank yous" styles={disbuttonstyle}/>
						{this.state.thankhover && thankyous}
					</div>
				</div>
				<div className={divStyle}>
					<div onMouseEnter={this.handlePrizeHover} onMouseLeave={this.handlePrizeHover}>
						<NavButton name="Prizes" styles={disbuttonstyle}/>
						{this.state.prizehover && options}
					</div>
				</div>
				<div className={divStyle}>
					<button onClick={this.props.logout} className={buttonstyle}>Logout</button>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/LovUserNav.js